import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Divider, Grid, Typography, TextField } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

interface ConfirmCheckoutOderCommentProps {
  orderComment: string
  onOrderCommentChange(orderComment: string): void
}

const useStyles = makeStyles()(theme => ({
  container: { paddingLeft: theme.spacing(4), paddingRight: theme.spacing(4), marginTop: theme.spacing(4) },
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
  inputField: {
    marginTop: theme.spacing(4),
  },
}))

const INPUT_MIN_ROWS = 5

/*
 * This component handle an optional input field if user want to leave a comment when creating an order.
 */
const ConfirmCheckoutOderComment: React.FC<ConfirmCheckoutOderCommentProps> = ({ orderComment, onOrderCommentChange }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <Grid item xs={12} md={6} className={classes.container}>
      <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
        {t('shop.confirm-checkout.order-comment')}
      </Typography>
      <Divider className={classes.normalText} variant="fullWidth" />
      <TextField
        className={classes.inputField}
        label={t('shop.confirm-checkout.order-comment-label')}
        value={orderComment}
        fullWidth
        multiline
        minRows={INPUT_MIN_ROWS}
        onChange={event => onOrderCommentChange(event.target.value)}
      />
    </Grid>
  )
}

export default ConfirmCheckoutOderComment
